module.exports = __webpack_public_path__ + "img/lens-150-plus-04.12da808f.png";